import http from '../../axios-config/g-http-metodos';

function gerarNovoOrcamento(data) {
  // if(data.constructor.name !== 'OrcamentoViewModel'){
  //   console.error('A Requisição espera um objeto da classe OrcamentoViewModel')
  //   return
  // }
  const { res, erro, requisicao, } = http.post('orcamento/post', data)
  return { res, erro, requisicao }
}

function GetOrcamentoByCartaPropostaId(CartaPropostaId) {
  const { res, erro, requisicao } = http.getArray(`Orcamento/GetOrcamentoByCartaPropostaId/${CartaPropostaId}`)
  return { OrcamentoArray: res , erro, requisicao }
}

function getOrcamentosAtivos() {
  const { res, erro, requisicao } = http.getArray('OrcamentoAll/Get')
  return { OrcamentoArray: res , erro, requisicao }
}

function DeletarOrcamentoDigitacao(orcamentoId){
  const { res, erro, requisicao } = http.post(`Orcamento/DeletarOrcamentoDigitacao/${orcamentoId}`);
  return { Sucesso: res, erro, requisicao };
}

function getOrcamentosByFiltro(filtros) {
  const { res, erro, requisicao } = http.post('orcamento/GetOrcamentosByFiltro', filtros)
  return { OrcamentoArray: res, erro, requisicao }
}

function GetRotaImagemProduto(orcamentoId){
  const { res, erro, requisicao } = http.get(`orcamento/GetRotaImagemProduto/${orcamentoId}`)
  return { res , erro, requisicao }
}

function getOrcamentosPendentesByFiltro(filtros) {
  const { res, erro, requisicao } = http.postArray('orcamento/GetOrcamentosPendentesByFiltro', filtros)
  return { OrcamentoArray: res , erro, requisicao }
}

function GetStatusOrcamentoEnum(){
  const{res , erro , requisicao} = http.get('Orcamento/GetStatusOrcamentoEnum')
  return {StatusArray: res , erro , requisicao}
}

function GetReorcamento(id) {
  const { res, erro, requisicao} = http.get(`Orcamento/GetTipoFluxoOrcamentoReorcamento/${id}`)
  return {ReorcamentoId: res, erro, requisicao}
}

function getOrcamentoLoteFreteByPedido(pedidoId) {
  const { res, erro, requisicao } = http.get(`Orcamento/GetOrcamentoLoteFretebyPedido/${pedidoId}`)
  return { PedidoLoteFreteArray: res, erro, requisicao }
}



function GetMotivoBaixa () {
  const{res , erro , requisicao} = http.get('Orcamento/GetMotivoBaixa')
  return {MotivoBaixaArray: res , erro , requisicao}
}

function GetCaracteristicasProduto(orcamentoId){
  const { res, erro, requisicao} = http.get(`Orcamento/getCaracteristicas/${orcamentoId}`)
  return {CaracteristicasProduto: res, erro, requisicao}
}

function GetNomeEmpresaByOrcamentoId(orcamentoId){
  const { res, erro, requisicao} = http.get(`Orcamento/GetNomeEmpresaByOrcamentoId/${orcamentoId}`)
  return {NomeEmpresa: res, erro, requisicao}
}


function GetCaracteristicasRepeticao(orcamentoId){
  const { res, erro, requisicao} = http.get(`Orcamento/getCaracteristicasRepeticao/${orcamentoId}`)
  return {CaracteristicasProduto: res, erro, requisicao}
}

function GetOrcamentoQuantidadeIdeal(orcamentoId){
  const { res, erro, requisicao} = http.get(`Orcamento/GetOrcamentoQuantidadeIdeal/${orcamentoId}`)
  return {QuantidadeArray: res, erro, requisicao}
}

function GetFormaPagamentoOrcamento(orcamentoId){
  const { res, erro, requisicao} = http.get(`Orcamento/GetFormaPagamentoOrcamento/${orcamentoId}`)
  return {FormaPagamento: res, erro, requisicao}
}

function SetMotivoBaixarOrcamento(motivo){
  const { res, erro, requisicao} = http.post(`Orcamento/SetMotivoBaixarOrcamento`, motivo)
  return {CaracteristicasProduto: res, erro, requisicao}
}

function GetEnumOrdenacao(){
  const { res, erro, requisicao } = http.getArray(`GerarNovoPedido/GetEnumOrdenacao`)
  return { OrdenacaoArray: res, erro, requisicao }
}

function getLinhaProducaoDropDownsByNome (){
  const { res, erro, requisicao } = http.get(`Orcamento/GetLinhaProducaoDropDownsByNome`)
  return { LinhaProducaoArray: res, erro, requisicao }
}

function GetStatusOrcamentoEnumPedido(){
  const{res , erro , requisicao} = http.get('Orcamento/GetStatusOrcamentoEnumPedido')
  return {StatusArray: res , erro , requisicao}
}

function GetConcorrentes(){
  const { res, erro, requisicao } = http.getArray("Orcamento/GetConcorrentes");
  return { ConcorrenteArray: res, erro, requisicao }
}
function DeleteOrcamento(orcamentoId){
  const { res, erro, requisicao} = http.postArray(`Orcamento/DeleteOrcamento/${orcamentoId}`)
  return {StatusArray: res, erro, requisicao}
}
function GetPedidoAtivo(orcamentoId){
  const { res, erro, requisicao} = http.get(`Orcamento/GetPedidoAtivo/${orcamentoId}`)
  return {PedidoAtivo: res, erro, requisicao}
}
function GetCodigoPedido(orcamentoId){
  const { res, erro, requisicao} = http.get(`Orcamento/GetCodigoPedido/${orcamentoId}`)
  return {CodigoPedido: res, erro, requisicao}
}
function getPermissaoReOrcamentos(){
  const { res, erro, requisicao} = http.get("Orcamento/GetPermissaoReOrcamentos")
  return {CodigoPedido: res, erro, requisicao}
}

function VerificaSeOrcamentoTemQuantidade(orcamentoId){
  const { res, erro, requisicao} = http.get(`Orcamento/VerificaSeOrcamentoTemQuantidade/${orcamentoId}`)
  return {TemQuantidade: res, erro, requisicao}
}

const OrcamentoController = {
  GetOrcamentoByCartaPropostaId,
  DeleteOrcamento,
  getPermissaoReOrcamentos,
  gerarNovoOrcamento,
  getLinhaProducaoDropDownsByNome,
  getOrcamentosAtivos,
  getOrcamentosByFiltro,
  getOrcamentosPendentesByFiltro,
  GetStatusOrcamentoEnum,
  GetReorcamento,
  GetCaracteristicasProduto,
  GetMotivoBaixa,
  GetOrcamentoQuantidadeIdeal,
  GetFormaPagamentoOrcamento,
  GetEnumOrdenacao,
  SetMotivoBaixarOrcamento,
  getOrcamentoLoteFreteByPedido,
  DeletarOrcamentoDigitacao,
  GetCaracteristicasRepeticao,
  GetRotaImagemProduto,
  GetStatusOrcamentoEnumPedido,
  GetNomeEmpresaByOrcamentoId,
  GetConcorrentes,
  GetPedidoAtivo,
  GetCodigoPedido,
  VerificaSeOrcamentoTemQuantidade
}

export default OrcamentoController;
